export const GET_USER_API_HASH = "GET_USER_API_HASH";